module.exports = __webpack_public_path__ + "static/media/small_aero_credit_icon.2ed4e05c.svg";